import { styled } from '@mui/system';
export var Link = styled('a')(function (_a) {
    var theme = _a.theme;
    return ({
        textDecoration: 'underline',
        fontWeight: 'bold',
        cursor: 'pointer',
        '&:hover': {
            color: theme.palette.primary.dark,
        },
    });
});
